export const ClientConfig = {
  ar: {
    clientname: "arkansas",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    useWaveLanguageSelections: true,
    showLanguageDropdown: true,
    crsLanguageSupport: {
      en: "English",
      es: "En español",
      ar: "العربية",
      mh: "Majol ",
      ru: "Русский",
      vi: "Tiếng Việt",
      ksw: "ကညီစှီၤကျိာ်",
      chi: "简体中文",
      pt: "Português",
      so: "Soomaali",
      sw: "Kiswahili",
      kur: "کوردی",
    },
    crsLanguageKeys: {
      en: "en",
      es: "es",
      ar: "ar",
      mh: "mh",
      ru: "ru",
      vi: "vi",
      ksw: "ksw",
      chi: "chi",
      pt: "pt",
      so: "so",
      sw: "sw",
      kur: "kur",
    },
    showInbox: true,
    displayIrpNotification: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "a86bdbc9-0e10-4395-b945-7bb1659b105d",
      },
      prod: {
        enabled: true,
        trackingId: "9929b448-51e7-4c7d-b275-35de147acf66",
      },
    },
    surveyModuleEnabled: false,
  },
  cambium: {
    clientname: "cambium",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    fetchHistoricalData: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "6d3e1692-0582-49e2-b6ba-e539098fcc86",
      },
      prod: {
        enabled: true,
        trackingId: "5107326e-7557-4298-bfc3-b94712021f6f",
      },
    },
  },
  ct: {
    clientname: "connecticut",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "00daf821-80a4-48ee-90e2-4e60f17c4bd7",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  de: {
    clientname: "delaware",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    crsLanguageSupport: { en: "English", es: "En español" },
    crsLanguageKeys: { en: "en", es: "es" },
    useWaveLanguageSelections: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "05c1e782-7801-43ff-ac17-443568c3f612",
      },
      prod: {
        enabled: true,
        trackingId: "96cfe6d5-6631-4967-897f-49fdf35857a3",
      },
    },
    surveyModuleEnabled: false,
  },
  fl: {
    clientname: "florida",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: false,
    crsLanguageSupport: { en: "English", es: "En español" },
    crsLanguageKeys: { en: "en", es: "es" },
    progressChartSettings: {
      removeConnectedLines: true,
      repeatCurrentYearPM3Progression: true,
    },
    useWaveLanguageSelections: true,
    showInbox: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "9373a175-03bb-468f-94cf-18667de2c9a0",
      },
      prod: {
        enabled: true,
        trackingId: "95675f84-9d1a-4102-b315-96445e77c0f2",
      },
    },
    testtypes: [
      { prefix: "fast pm", type: "k-2" },
      { prefix: "fast pm", type: "pre-k" },
      { prefix: "writing", type: "best" },
      { prefix: "fact", type: "fact", useTextBasedAchievementLevel: true },
    ],
    surveyModuleEnabled: false,
  },
  hi: {
    clientname: "hawaii",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    showVideoReports: true,
    crsLanguageSupport: { en: "English", es: "En español" },
    crsLanguageKeys: { en: "en", es: "es" },
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "e0f23ab0-cac2-468a-a74c-bae637788c0c",
      },
      prod: {
        enabled: true,
        trackingId: "694d12b7-7d6b-45b9-a977-5a435320bd16",
      },
    },
    surveyModuleEnabled: false,
  },
  ia: {
    clientname: "iowa",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "d490bf0e-eddc-4e4e-91c4-f47b1a65d55f",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  id: {
    clientname: "idaho",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "cdcc2267-b0d0-4da1-90ed-c8fc47b6b82a",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  in: {
    clientname: "indiana",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: true,
    useWaveLanguageSelections: true,
    showLanguageDropdown: true,
    reportingCategoriesSettings: {
      forceShowPerformanceColumn: true,
    },
    crsLanguageSupport: {
      en: "English",
      es: "En español",
      ar: "العربية",
      vi: "Tiếng Việt",
      chi: "简体中文",
      my: "မြန်မာ",
      cnh: "Lai Hakha",
    },
    crsLanguageKeys: {
      //crs key:fp key
      en: "en",
      es: "es",
      ar: "ar",
      vi: "vi",
      chi: "chi",
      bur: "my",
      cnh: "cnh",
    },
    shouldFormatLexileQuantileScore: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "e6f59584-cc01-476d-ae1c-0f1551ca57f9",
      },
      prod: {
        enabled: true,
        trackingId: "189b686b-5d7e-41c3-95d3-5f0896c25b0e",
      },
    },
    surveyModuleEnabled: false,
  },
  la: {
    clientname: "louisiana",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "8c319b06-c1a3-4ef7-ba20-a843057ae3b7",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  mt: {
    clientname: "montana",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "fbb52395-3eec-4b51-a516-007d63c5753b",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  ne: {
    clientname: "nebraska",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "291a1261-8917-4710-a2ff-ffd51f8092f8",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  nh: {
    clientname: "newhampshire",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: false,
    useWaveLanguageSelections: true,
    showLanguageDropdown: true,
    crsLanguageSupport: {
      en: "English",
      es: "En español",
      pt: "Português",
      sw: "Kiswahili",
    },
    crsLanguageKeys: {
      en: "en",
      es: "es",
      pt: "pt",
      sw: "sw",
    },
    detailedViewTabsStartingYear: 2023,
    //progressTabStartingYear: 2024,
    progressTabDisplayLongitudinalText: true,
    quantileTabHideCCRText: true,
    progressChartSettings: {
      formatDateForXaxis: true,
      xAxisRotationDegrees: -45,
    },
    shouldFormatLexileQuantileScore: true,
    translateTestWindowDirectly: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "bd374fec-4d53-4b2d-a01b-01a0d41050bc",
      },
      prod: {
        enabled: true,
        trackingId: "f101e713-3a07-42b9-ab2f-5a3a4a28c047",
      },
    },
    surveyModuleEnabled: false,
  },
  nd: {
    clientname: "northdakota",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "26644dbd-c34e-4417-886c-a67aa008bec8",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  oh: {
    clientname: "ohio",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "f01dfa9a-4062-4b0d-ad7f-e6e8ff81c847",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  or: {
    clientname: "oregon",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "d16db33a-8dad-49f1-a9c8-955b5fd6fd38",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  ri: {
    clientname: "rhodeisland",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "47429104-c5fe-4d84-b51c-1a8a046077e8",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  sc: {
    clientname: "southcarolina",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "3c025e5d-5361-4693-8dce-4aebac7e7c57",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  sd: {
    clientname: "southdakota",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "fcd4a094-93d7-4378-9e6a-3044f498ea0e",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  tx: {
    clientname: "texas",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: true,
    fetchHistoricalData: true,
    fetchEocScores: true,
    useWaveLanguageSelections: true,
    progressTabDisplayLongitudinalText: true,
    fullSubscriptionModal: true,
    privacyPolicyTermsUrl: "https://privacypolicy.cambiumassessment.com/",
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "52ca7b44-5314-49c5-8087-40ba7d719cba",
      },
      prod: {
        enabled: true,
        trackingId: "0f1b83e3-f8bc-408b-a6d9-7932bc92f0d1",
      },
    },
    testtypes: [{ prefix: "telpas", type: "telpas" }],
    surveyModuleEnabled: false,
  },
  ut: {
    clientname: "utah",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "967dbcb0-a1ab-4524-9841-573c98d32865",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  vt: {
    clientname: "vermont",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "392c8470-b1f1-47ae-a207-88efef4c1b6e",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  vi: {
    clientname: "virginislands",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    showLanguageDropdown: true,
    crsLanguageSupport: { en: "English", es: "En español" },
    crsLanguageKeys: { en: "en", es: "es" },
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "52a984bf-8cce-447c-8251-7fc63bd6c5f9",
      },
      prod: {
        enabled: true,
        trackingId: "1c575338-de66-46e9-bfb2-b627e2d464d3",
      },
    },
    surveyModuleEnabled: false,
  },
  wa: {
    clientname: "washington",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "3ce7d0b4-92d4-4d23-96d5-64b26920abf1",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  wv: {
    clientname: "westvirginia",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: false,
    useWaveLanguageSelections: true,
    showLanguageDropdown: true,
    crsLanguageSupport: { en: "English", es: "En español" },
    crsLanguageKeys: { en: "en", es: "es" },
    reportingCategoriesSettings: {
      forceShowPerformanceColumn: true,
    },
    detailedViewTabsStartingYear: 2023,
    progressTabDisplayLongitudinalText: true,
    progressChartSettings: {
      formatDateForXaxis: true,
      xAxisRotationDegrees: -45,
    },
    shouldFormatLexileQuantileScore: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "18e6dc0e-eba5-41e7-b0fe-71b5e366827a",
      },
      prod: {
        enabled: true,
        trackingId: "bdbdbbbc-e9db-419a-985b-0dc7794b1e80",
      },
    },
    surveyModuleEnabled: false,
  },
  wy: {
    clientname: "wyoming",
    layout: "basic",
    showFullLayoutSubjectsHomeScreen: false,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "9a143683-ec94-4ec7-88d7-eac87d7a8133",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  tn: {
    clientname: "tennessee",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: false,
    crsLanguageSupport: { en: "English" },
    crsLanguageKeys: { en: "en" },
    useWaveLanguageSelections: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "1e039629-b049-40f6-abb7-2c66b87eded3",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
    surveyModuleEnabled: false,
  },
  pa: {
    clientname: "clientdemo",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: false,
    crsLanguageSupport: { en: "English" },
    crsLanguageKeys: { en: "en" },
    useWaveLanguageSelections: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "b6953ea2-1be5-47be-bddf-8048311935bb",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
  },
  cd: {
    clientname: "clientdemo",
    layout: "full",
    showFullLayoutSubjectsHomeScreen: false,
    crsLanguageSupport: { en: "English" },
    crsLanguageKeys: { en: "en" },
    useWaveLanguageSelections: true,
    umamiSettings: {
      canUseUmami: true,
      uat: {
        enabled: true,
        trackingId: "f015ec4d-61e5-4617-a946-b1d47377297d",
      },
      prod: {
        enabled: false,
        trackingId: "",
      },
    },
  },
};
